import { mapGetters } from 'vuex'
import trustCenterDocument from '@/mixins/trustCenterDocument'
import { isEmailAllowedBySettings } from '@/logicJs/emailUtils'

/**
 * Mixin for questionnaire upload settings and permissions
 * Provides computed properties for checking if self-service and send-to-admin options are allowed
 */
export default {
  mixins: [trustCenterDocument],

  computed: {
    ...mapGetters(['GET_CURRENT_USER']),

    /**
     * Get questionnaire upload self-service settings from trust center settings
     * @returns {Object} Settings object with mode, blacklistEmails, whitelistEmails
     */
    questionnaireUploadSelfServiceSettings() {
      return (
        this.getTrustCenterByType('trustCenterSettings')
          ?.questionnaireUploadSelfService || {
          mode: 'denyAllExceptWhitelist',
          blacklistEmails: [],
          whitelistEmails: [],
        }
      )
    },

    /**
     * Get questionnaire upload send-to-admin settings from trust center settings
     * @returns {Object} Settings object with mode, blacklistEmails, whitelistEmails
     */
    questionnaireUploadSendToAdminSettings() {
      return (
        this.getTrustCenterByType('trustCenterSettings')
          ?.questionnaireUploadSendToAdmin || {
          mode: 'denyAllExceptWhitelist',
          blacklistEmails: [],
          whitelistEmails: [],
        }
      )
    },

    /**
     * Get current user's email
     * @returns {string} User email or empty string
     */
    userEmail() {
      return this.GET_CURRENT_USER?.email || ''
    },

    /**
     * Check if self-service (AI) questionnaire upload is allowed for the current user
     * @returns {boolean} True if allowed, false otherwise
     */
    isSelfServiceAllowed() {
      return isEmailAllowedBySettings(
        this.userEmail,
        this.questionnaireUploadSelfServiceSettings
      )
    },

    /**
     * Check if send-to-admin (Human Analyst) questionnaire upload is allowed for the current user
     * @returns {boolean} True if allowed, false otherwise
     */
    isSendToAdminAllowed() {
      return isEmailAllowedBySettings(
        this.userEmail,
        this.questionnaireUploadSendToAdminSettings
      )
    },
  },
}
